module.exports = __webpack_public_path__ + "img/nt85-04-82-1.prt.b7913354.jpg";